/**
 * Returns the border-radius CSS var of a specified size.
 *
 * @example
 * borderRadius('medium');
 * // 'var(--ods-border-radius-medium)'
 */
export function borderRadius(size) {
    return `var(--ods-border-radius-${size})`;
}
//# sourceMappingURL=border-radius.js.map